import styled, { css } from 'styled-components';
import { media } from '../theme/base/mixins';
import { StyledComponent } from '../types';

interface ArticleProps {
  padding?: string;
  textpic?: boolean;
}

export const Article: StyledComponent<ArticleProps> = styled.article`
  position: relative;
  padding: ${(props: ArticleProps) => props.padding};

  ${(props: ArticleProps) =>
    props.textpic &&
    css`
      img {
        margin-bottom: 20px;
      }
    `}

  /* medium breakpoint */
  ${media.medium`
    ${(props: ArticleProps) =>
      props.textpic &&
      css`
        img {
          margin-bottom: 0;
        }
      `}
  `};
`;
